import React from 'react';
import { observer } from 'mobx-react';
import './timeAxis.less';
import autobind from 'autobind-decorator';
import Swiper from '../../com/swiper-3.3.1.min';
import '../../com/swiper-3.3.1.min.css';

interface TimeAxisState {
    current: any;
}

interface TimeAxisPropType {
    prefixCls?: string;
    navigat?: any[];
    type?: any;
    onChannelClick?: any;
    currentIndex?: any;
    onClick?: (item, index) => void;
    timeFixed?: any;
    transformClass?: any;
}

@observer
class TimeAxis extends React.Component<TimeAxisPropType, TimeAxisState> {
    static defaultProps = {
        prefixCls: 'timeAxis',
    };

    constructor(props, context) {
        super(props, context);
    }

    swiper: any;


    componentWillMount() {

    }

    componentDidMount() {
        // 是否点击首页
        this.swiper = new Swiper(
            '#timeAxis', {
                freeMode: true,
                freeModeMomentumRatio: 0.5,
                slidesPerView: 'auto',
                observer: true, // 修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, // 修改swiper的父元素时，自动初始化swiper
            }
        );
    };

    itemNav = (index) => {
        const {prefixCls, currentIndex} = this.props;
        // const {current} = this.state;
        return index === currentIndex ? `swiper-slide active ${prefixCls}-times-box` : `swiper-slide ${prefixCls}-times-box`;
    };

    @autobind
    onTabClick(index, item) {
        if (this.props.onClick) {
            this.props.onClick(item, index);
        }
    }

    render() {
        const {prefixCls, navigat = [], timeFixed, currentIndex, transformClass} = this.props; // type
        return (
            <div id="timeAxis"
                 className={!timeFixed ? `swiper-container ${prefixCls}-swipper` : `${transformClass} swiper-container ${prefixCls}-swipper`}>
                <div className="swiper-wrapper">
                    {
                        navigat && navigat.map((item: any, index: number) => {
                            return (
                                <div
                                    key={index}
                                    className={this.itemNav(index)}
                                    onClick={() => {
                                        this.onTabClick(index, item);
                                    }}>
                                    <div
                                        className={currentIndex == index ? `${prefixCls}-times-active` : `${prefixCls}-times`}>{item.name}</div>
                                    <div
                                        className={currentIndex == index ? `${prefixCls}-times-bottom-active` : `${prefixCls}-times-bottom`}>{item.slogan}</div>
                                    {currentIndex == index && <div className={`${prefixCls}-bottom-line`}/>}
                                </div>
                            );

                        })
                    }
                </div>
            </div>
        );
    }
}

export default TimeAxis;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/timeAxis/timeAxis.tsx